module.exports = __webpack_public_path__ + "static/media/cms10.6fb44346.png";